export default __webpack_public_path__ + "static/media/pkomora.4e776cac.png";